import React from 'react'
import { connect } from 'react-redux'
import {  Row,  Table } from 'react-bootstrap'

import SearchBarDashboard from '../../../components/SearchBarDashboard'
import PropertyTitle from '../../../components/PropertyTitle'
import 'react-toggle/style.css'
import * as XLSX from 'xlsx';

import {getUserInfoDashboard} from '../../../actions/user-actions';
import { NO_SEARCH_RESULTS } from '../../messages'


class UserInfoPerProductEanOverview extends React.Component {

    constructor() {
        super()
        this.state = { query: undefined, isSearching: false }
      }

      componentDidMount() {
        if(this.props.query) {
          this.setState({ query: this.props.query })
        }
      }

      componentWillUnmount() {
         this.setState({ query: undefined })
      }

      search(query) {
        this.setState({ query, overViewmode: true, isSearching: true })
        this.props.getUserInfoDashboard(query).then(() => {
          this.setState({ isSearching: false })
        })
      }

      downloadExcel = (data, ean) => {
        if( data.length) {
          const name = "DataSheet_EAN_" + ( ean? ean : '1' ) + ".xlsx";
          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();

          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          XLSX.writeFile(workbook, name);
        }
      };

    
      render() {
        const { productResults, query } = this.props
    
        return <div className='content-changeUserId' >
          <Row className='dashboardRowContainer'>
            <PropertyTitle 
              icon='key' 
              text=" Actieve licenties" 
            />
            <Row >
              <div style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
                <div style={{borderBottom:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"5px",  marginBottom:"10px"}}>
                  Zoek actieve licenties voor EAN. Vul hieronder de EAN in waarop u wilt zoeken.
                  </div>
                  <SearchBarDashboard style={{ backgroundColor:"white", padding:"5px",  marginTop:"5px"}}
                  placeholder="EAN"
                  value={ this.state.query || this.props.query }
                  callback={(query) => this.search(query)}
                  isLoading={this.state.isSearching}
                  />
                </div>
            </Row>
          </Row>
          <Row style={{display:"flex", marginRight:"-50px", marginBottom:"20px"}}>
          { productResults && productResults.length? (
            <><div style={{display:"flex", flexDirection:"row", alignItems:"flex-end", gap:"10px", padding:"10px", margin:"10px", marginLeft:"-10px"}} >Aantal gebruikers met deze licentie: {productResults.length}</div>
            <button className="button-dashboard-product" style={{marginLeft:"60%"}} onClick={() => this.downloadExcel(productResults, this.state.query)}>Exporteren naar Excel</button></>
            ): (
              <div />
            )}
          </Row>
          <Row>
            <div className="tablescontainer" style={{marginTop:"5px"}}>
              { productResults && productResults.length? (
                <Table striped>
                  <thead style={{borderTop:"1px solid black", background:"none"}}>
                    <tr style={{borderTop:"1px solid black", background:"none", color:"black"}}>
                      <th style={{width:"25%"}}>Voornaam</th>
                      <th style={{width:"25%"}} >Achternaam</th>
                      <th style={{width:"25%"}} >E-mail</th>
                      <th style={{width:"25%"}} >Organisatie</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productResults.map((product, index) => (
                      <tr key={index} >
                      <td style={{width:"25%"}} >{product.firstName}</td>
                      <td style={{width:"25%"}}>{product.lastName ? product.lastName : ""}</td>
                      <td style={{width:"25%"}}>{product.email ? product.email : ""}</td>
                      <td style={{width:"25%"}}>{product.organisation ? product.organisation : "" }</td>
                    </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                this.state.query && !this.state.isSearching ? <div>{NO_SEARCH_RESULTS}</div> : <div />
              )}
            </div>
          </Row>
        </div>
      }

    
}


  export default connect((state) => {
    return { 
    productResults: state.users.userSearch.results.users,
    selectedProduct: state.products.detail,
    query: state.users.userSearch.results.query
  }}, {
    getUserInfoDashboard,
  })(UserInfoPerProductEanOverview)